import { PropTypes } from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import { Divider, Dropdown, Table, Tag, Tooltip,
} from 'antd';
import H3DateSelector from '@Uilib/h3DateSelector';
import { FilterOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { v4 as uuidv4 } from 'uuid';
import { toISTDate } from '@Apis/constants';
import PRZText from '../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';

const TallyUnMappedDocuments = ({
  user, history, getTallyUnMappedDocuments, tallyUnMappedDocuments, getTallyUnMappedDocumentsLoading, currentTab, counter, getTallyDocumentsCount,
  getTallyDocumentsCountLoading, MONEY, showDrawer,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedTenantIds, setSelectedTenantIds] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [call, setCall] = useState(false);
  const [limit, setLimit] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getTallyColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.entity_number ? record.entity_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={record?.status?.replaceAll('_', ' ')?.toProperCase() || '-'}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    title={(
                      <Link
                      // to={
                      //   (record?.entity_name === 'invoice' || record?.entity_name === 'credit_note') ? `/sales/customer/view/${record?.party_ledger_id}`
                      //     : `/vendors/view/${record?.party_ledger_id}`
                      // }
                      // target="_blank"
                      >
                        <PRZText
                          className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                          text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`}
                        />
                      </Link>
                    )}
                    color="white"
                  >
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`}
                    />
                  </Tooltip>
                </div>
                <PRZText
                  text={`Location - ${record?.entity_location}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Document Date - ${toISTDate(record?.entity_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Ledger Total"
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    text={`${MONEY(record?.document_grand_total)}`}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Document Type"
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    text={`${record?.entity_name?.split('_')?.join(' ')?.toProperCase() || ''}`}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Exception"
                    />
                  )}
                  color="white"
                >
                  <PRZText
                    style={{
                      color: 'black',
                    }}
                    className="mobile-list__card_footer__other-status"
                    text={record?.account_name == null ? (record?.entity_name == 'good_receiving_note' ? 'Purchase Ledger is not mapped' : record?.entity_name == 'debit_note' ? 'Purchase Return Ledger is not mapped' : record?.entity_name == 'invoice' ? 'Sales Ledger is not mapped' : 'Sales Return Ledger is not mapped') : ''}
                  />
                  <PRZText
                    style={{
                      color: 'black',
                    }}
                    className="mobile-list__card_footer__other-status"
                    text={record?.discount_account_name == null ? 'Discount Ledger is not mapped' : ''} />
                  <PRZText
                    style={{
                      color: 'black',
                    }}
                    className="mobile-list__card_footer__other-status"
                    text={record?.freight_account_name == null ? 'Freight Ledger is not mapped' : ''} />
                  <PRZText
                    style={{
                      color: 'black',
                    }}
                    className="mobile-list__card_footer__other-status"
                    text={record?.roundoff_account_name == null ? 'Roundoff Ledger is not mapped' : ''}
                  />
                </Tooltip>
                &nbsp;
              </div>
              <div className="mobile-list__card_footer-right">
                <div />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'Location',
        render: (record) => (
          <div>
            <H3Text text={record?.entity_location} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document Type',
        render: (record) => (
          <div>
            <H3Text text={`${record?.entity_name?.split('_')?.join(' ')?.toProperCase() || ''}`} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document',
        render: (record) => (
          <div className="associated-entity">
            <Link
              to={record?.entity_name === 'invoice' ? `/sales/invoice/view/${record?.entity_id}`
                : (record?.entity_name === 'credit_note' ? `/sales/credit-note/view/${record?.entity_id}` : record?.entity_name === 'debit_note' ? `/purchase/debit-note/view/${record?.entity_id}` : `/purchase/goods-receiving/view/${record?.entity_id}`)}
              target="_blank"
            >
              {record?.entity_number}
            </Link>
          </div>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Status',
        render: (record) => (
          <div style={{ color: Helpers.getStatusColor(record?.status).color }}>
            {record?.status?.replaceAll('_', ' ') || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Party Name',
        render: (record) => (
          <div className="associated-entity">
            <Link
              to={
                (record?.entity_name === 'invoice' || record?.entity_name === 'credit_note') ? `/sales/customer/view/${record?.party_ledger_id}`
                  : `/vendors/view/${record?.party_ledger_id}`
              }
              target="_blank"
            >
              <H3Text text={`${record?.party_ledger_info?.customer_name || record?.party_ledger_info?.seller_name || ''}`} />
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Ledger Total',
        render: (record) => (
          <div className="column-amount">
            <H3Text text={`${MONEY(record?.document_grand_total)}`} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Created Date',
        render: (record) => (
          <div className="column-date">
            <H3Text text={toISTDate(record?.created_at || '').format('MMM DD, YYYY')} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Document Date',
        render: (record) => (
          <div className="column-date">
            <H3Text text={toISTDate(record.entity_date).format('MMM DD, YYYY')} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Exception',
        render: (record) => (
          <div className="column-exception__wrapper">
            <H3Text text={record?.account_name == null ? (record?.entity_name == 'good_receiving_note' ? 'Purchase Ledger is not mapped' : record?.entity_name == 'debit_note' ? 'Purchase Return Ledger is not mapped' : record?.entity_name == 'invoice' ? 'Sales Ledger is not mapped' : 'Sales Return Ledger is not mapped') : ''} />
            <H3Text text={record?.discount_account_name == null ? 'Discount Ledger is not mapped' : ''} />
            <H3Text text={record?.freight_account_name == null ? 'Freight Ledger is not mapped' : ''} />
            <H3Text text={record?.roundoff_account_name == null ? 'Roundoff Ledger is not mapped' : ''} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];

    return columns.filter((item) => !item.hidden);
  };

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: uuidv4() }));
    }
    return [];
  };

  const pushParamsToUrl = (page, pageLimit, keyword, toDate, fromDate, tenantIds) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (pageLimit) url += `&limit=${pageLimit}`;
    if (keyword) url += `&keyword=${keyword}`;
    if (toDate) url += `&to_date=${toDate}`;
    if (fromDate) url += `&from_date=${fromDate}`;
    if (tenantIds) url += `&tenant=${tenantIds}`;

    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      setSelectedTenantIds((Helpers.getValueFromUrl('tenant')?.split(',')?.length > 1 ? 'All' : Number(Helpers.getValueFromUrl('tenant'))) || user?.tenant_info?.tenant_id);
      setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      setStartDate(Number(Helpers.getValueFromUrl('from_date')));
      setEndDate(Number(Helpers.getValueFromUrl('to_date')));
      setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    if (isUserReady || !showDrawer) {
      getTallyDocumentsCount(user?.tenant_info?.tenant_id, (data) => {
        counter({
          unMappedCount: data?.unmapped_count,
          readyToPushCount: data?.ready_to_push_count,
          completedCount: data?.completed_count,
          errorCount: data?.error_count,
          excludedDocCount: data?.exclude_document_count,
        });
      });
      pushParamsToUrl(currentPage, limit, searchKeyword, startDate, endDate, selectedTenant);
      getTallyUnMappedDocuments(selectedTenant || user?.tenant_info?.tenant_id, startDate, endDate, currentPage, limit, (_data) => {
        counter((prevCounter) => ({
          ...prevCounter,
          unMappedCount: _data?.count,
        }));
      });
      setIsUserReady(false);
    }
  }, [currentPage, searchKeyword, selectedTenant, startDate, endDate, call, currentTab, limit, showDrawer]);

  return (
    <div className="doc-list__wrapper doc-list__tab-content">
      <div className="ant-row">
        <div className="ant-col-md-24 ant-col-xs-24">
          <div className="doc-list__header-wrapper" />
          <div className="header__tags">
            {
              (startDate && endDate) ? (
                <Tag
                  closable
                  onClose={() => {
                    setStartDate(null);
                    setEndDate(null);
                  }}
                  color="#2d7df7"
                >
                  {' '}
                  From:
                  &nbsp;
                  <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                  &nbsp;
                  To:
                  &nbsp;
                  <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                </Tag>
              ) : ''
            }
            {selectedTenant && selectedTenant?.map((item) => (
              <Tag
                key={item}
                closable
                onClose={() => {
                  setCurrentPage(1);
                  setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                }}
                color="#2d7df7"
              >
                Business Unit -
                &nbsp;
                <span>
                  <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                </span>
              </Tag>
            ))}
          </div>
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    <H3Text text={`${(tallyUnMappedDocuments && tallyUnMappedDocuments?.count) ? tallyUnMappedDocuments?.count : '0'} Documents`} className="" />
                  </div>
                  <div className="doc-list__table-header__right">
                    <div className="doc-list__filter-buttons">
                      <H3DateSelector
                        startDate={startDate}
                        endDate={endDate}
                        onDateChange={(date) => {
                          setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                          setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                        }}
                      />
                    </div>
                    <Dropdown
                      trigger={['click']}
                      overlay={(
                        <div className="header__filter__container">
                          <div className="header__filter__container__title">
                            Apply Filters
                          </div>
                          <div className="filter__container filter__container-section">
                            <div className="filter__title">Business Unit</div>
                            <TenantSelector
                              selectedTenant={selectedTenant}
                              showSearch
                              onChange={(value) => {
                                setSelectedTenant(value);
                              }}
                              placeholder="Select Business Unit"
                              isMultiple
                              hideTitle
                              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ)}
                            />
                          </div>
                        </div>
                      )}
                    >
                      <div className="doc-list__action-buttons">
                        <div className="action-button">
                          <H3Text text="Filters" className="action-button-text" />
                          <FilterOutlined />
                        </div>
                      </div>
                    </Dropdown>
                  </div>
                </div>
              )}
              loading={getTallyUnMappedDocumentsLoading || getTallyDocumentsCountLoading}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              columns={getTallyColumns()}
              dataSource={getDataSource(tallyUnMappedDocuments?.data || [])}
              rowKey="entity_number"
              pagination={{
                defaultCurrent: currentPage,
                current: currentPage,
                total: tallyUnMappedDocuments ? tallyUnMappedDocuments?.count : 0,
                pageSize: limit,
                showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                onChange: (page, pageSize) => {
                  setCurrentPage(page);
                  setLimit(pageSize);
                  setSelectedRows([]);
                  setSelectedRowKeys(null);
                },
                position: ['bottomLeft'],
                showSizeChanger: true,
                pageSizeOptions: [10, 25, 50, 100],
              }}
              rowSelection={!isMobileOrPortrait ? {
                onChange: (rowKeys, rows) => {
                  setSelectedRowKeys(rowKeys);
                  setSelectedRows(rows);
                },
                selectedRowKeys,
              } : false}
              bordered
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TallyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  tallyUnMappedDocuments: TallyIntegrationReducers.tallyUnMappedDocuments,
  getTallyUnMappedDocumentsLoading: TallyIntegrationReducers.getTallyUnMappedDocumentsLoading,
  getTallyDocumentsCountLoading: TallyIntegrationReducers.getTallyDocumentsCountLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallyUnMappedDocuments: (tenantIds, startDate, endDate, page, limit, callback) => dispatch(TallyIntegrationActions.getTallyUnMappedDocuments(tenantIds, startDate, endDate, page, limit, callback)),
  getTallyDocumentsCount: (tenantIds, callback) => dispatch(TallyIntegrationActions.getTallyDocumentsCount(tenantIds, callback)),
});

TallyUnMappedDocuments.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyUnMappedDocuments));
